export class DateDto {

 Year:string;
 Month:string;
 Day:string;
 Hour:string;
 Minute:string;

}
